<h2 mat-dialog-title style="text-align:center; margin-bottom: 16px;">Transfer destination</h2>

<mat-dialog-content *ngIf="storageTypes as storageTypes">

  <mat-form-field class="form-field" color="accent" id="form-field-destination">
    <mat-label>Destination</mat-label>
    <mat-icon matPrefix>cloud_upload</mat-icon>
    <mat-select [(ngModel)]="storageTypeId">
      <mat-option *ngFor="let storageType of storageTypes" [value]="storageType.id">
        {{storageType.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions>


    <button color="warn" mat-dialog-close mat-stroked-button>
        <mat-icon>cancel</mat-icon>Cancel
    </button>

    <button (click)="onTransfer()" color="accent" mat-flat-button>
        <mat-icon>downloading</mat-icon>Transfer
    </button>


<!-- <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar> -->

</mat-dialog-actions>
